export default __webpack_public_path__ + "static/media/background_about_us.9fc31b98.png";